const Routes = {
  Root: '/',
  Features: '/features',
  Login: '/login',
  ForgotPassword: '/forgot-password/',
  ResetPassword: '/reset-password/:token',
  Register: '/register/',
  SetupAccount: '/setup-account/:token',
  Home: '/home',
  Inbox: '/home/inbox',
  Areas: '/home/areas',
  Area: '/home/areas/:areaId',
  Employees: '/home/areas/:areaId/employees',
  AlertsAndNotifications: '/home/areas/:areaId/alerts-and-notifications',
  Groups: '/home/areas/:areaId/groups',
  Group: '/home/areas/:areaId/groups/:groupId',
  JobSchedule: '/home/jobschedule',
  EmployeeSchedule: '/home/employeeschedule',
  TimeOffCalendar: '/home/timeoffcalendar',
  TimeOffList: '/home/timeofflist',
  Timecard: '/home/timecard',
  TimecardSummary: '/home/timecardsummary',
  TimecardTest: '/home/timecardtest',
  Batch: '/home/batch',
  AdjustmentsBatch: '/home/adjustmentsbatch',
  BatchSummary: '/home/batchsummary',
  Settings: '/home/settings',
  Report: '/home/report',
  Analytics: '/home/report/analytics',
  SearchBase: '/home/search/',
  Search: '/home/search/:searchTerms',
  SearchAreaBase: '/home/areas/:areaId/search/',
  SearchArea: '/home/areas/:areaId/search/:searchTerms',
  SearchGroupBase: '/home/areas/:areaId/groups/:groupId/search/',
  SearchGroup: '/home/areas/:areaId/groups/:groupId/search/:searchTerms',

  /********* Temporary **********/
  toSetupAccount(token: string): string {
    return this.SetupAccount.replace(/:token/, token);
  },
  toResetPassword(token: string): string {
    return this.ResetPassword.replace(/:token/, token);
  },
  /******************************/

  toEmployees(areaId: string): string {
    return this.Employees.replace(/:areaId/, areaId);
  },

  toAlertsAndNotifications(areaId: string): string {
    return this.AlertsAndNotifications.replace(/:areaId/, areaId);
  },

  toArea(areaId: string): string {
    return this.Area.replace(/:areaId/, areaId);
  },

  toGroup(areaId: string, groupId: string): string {
    return this.Group.replace(/:areaId/, areaId).replace(/:groupId/, groupId);
  },

  toReport(): string {
    return this.Report;
  },

  toSearch(areaId?: string, groupId?: string, searchTerms?: string[]): string {
    let route: string;

    if (!areaId && !groupId) {
      route = this.Search;
    } else if (!groupId) {
      route = this.SearchArea.replace(/:areaId/, areaId);
    } else {
      route = this.SearchGroup.replace(/:areaId/, areaId).replace(/:groupId/, groupId);
    }
    if (searchTerms?.length) {
      route = route.replace(/:searchTerms/, searchTerms.join('+'));
    }
    return route;
  },
};

export default Routes;
